import { Card, Descriptions } from 'antd';
import React, { memo } from 'react';
import { getStatusTag } from '../utils';

/**
 * Component for displaying applicant status information
 * @param {Object} props - Component props
 * @param {Object} props.data - Applicant data object
 */
const StatusInfo = memo(({ data }) => {
    if (!data) return null;

    // Focus only on the most important status items for better performance
    const statusItems = [
        { label: "Requirements Status", value: data.admissionRequirementsStatus },
        { label: "Exam & Interview Status", value: data.preferredExamAndInterviewApplicationStatus },
        { label: "Approval Status", value: data.admissionApprovalStatus },
        { label: "Registration Status", value: data.registrationStatus }
    ].filter(item => item.value); // Only include items with values

    return (
        <Card className="mb-4">
            <Descriptions title="Application Status" bordered column={1}>
                {statusItems.map((item, index) => (
                    <Descriptions.Item key={index} label={item.label}>
                        {getStatusTag(item.value)}
                    </Descriptions.Item>
                ))}
            </Descriptions>
        </Card>
    );
});

export default StatusInfo;
